/* RubyGator pre-orders: when the cart refuses more units of a pre-order product,
   the theme's error dialog shows the pre-order message (data-rg-po-limit) instead of the generic text. */
(function () {
  var last = null;
  var SCOPES = '.bls__product-item, .bls__product-details-infor, .bls__product-quickview, .dlg-box, .product-list-item';

  function limitFor(el) {
    var scope = el.closest(SCOPES);
    var holder = scope && scope.querySelector('[data-rg-po-limit]');
    // The sticky bar and other forms on a product page use the panel of the main product
    if (!holder && document.body.classList.contains('template-product')) {
      holder = document.querySelector('.rg-po-panel[data-rg-po-limit]');
    }
    return holder ? holder.getAttribute('data-rg-po-limit') : null;
  }

  function remember(event) {
    var el = event.target && event.target.closest ? event.target : null;
    if (!el) return;
    if (event.type === 'click' && !el.closest('button, [type="submit"]')) return;
    var msg = limitFor(el);
    last = msg ? { msg: msg, at: Date.now() } : null;
  }

  document.addEventListener('click', remember, true);
  document.addEventListener('submit', remember, true);

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function patch() {
    if (!window.EasyDialogBox || EasyDialogBox.rgPreorder) return;
    var create = EasyDialogBox.create;
    EasyDialogBox.create = function (id, cls, title, message) {
      if (id === 'add_cart_error' && last && Date.now() - last.at < 20000) {
        var en = (document.documentElement.lang || '').indexOf('en') === 0;
        message =
          '<div class="rg-po-dialog"><p class="rg-po-dialog__title">' +
          (en ? 'Pre-order limit reached' : 'Pre-order limiet bereikt') +
          '</p><p class="rg-po-dialog__text">' + escapeHtml(last.msg) + '</p></div>';
        var args = Array.prototype.slice.call(arguments);
        args[3] = message;
        return create.apply(this, args);
      }
      return create.apply(this, arguments);
    };
    EasyDialogBox.rgPreorder = true;
  }

  patch();
  if (!window.EasyDialogBox) {
    document.addEventListener('DOMContentLoaded', patch);
  }
})();
